import { Component } from '@angular/core';

@Component({
  selector: 'common-footer',
  templateUrl: './common-footer.template.html',
  styleUrls:['./common-footer.component.css']
})

export class FooterComponent {
  protected year = new Date().getFullYear();

  constructor() {

  }
}




// WEBPACK FOOTER //
// ./src/app/components/common-footer/common-footer.component.ts